export const PAGE_PATH = '/activity';
